import React, {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {Wrapper} from './CreateTimeOffRequest.style'

import Button from "../../../../shared/components/Button/Button";
import Calendar from "../../../../shared/components/Calendar/Calendar";
import Dropdown from "../../../../shared/components/Dropdown/Dropdown";
import TextArea from "../../../../shared/components/TextArea/TextArea";

import TimeOffService from '../TimeOff.service'

import {showToast} from '../../../../shared/utils/showToast'
import { useKeypress } from "../../../../hooks";

const CreateTimeOffRequest = ({hideModal, onCreate, setLoadingModal}) => {
    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)
    const [reason, setReason] = useState(null)
    const [requestNote, setRequestNote] = useState("")
    const [timeOffReasons, setTimeOffReasons] = useState(['Vacation', 'Sick Leave', 'Personal', 'Work From Home'])
    const [errors, setErrors] = useState(null)
    const {user} = useSelector(state => state.auth)

    useEffect(() => {
        user.is_admin && setTimeOffReasons([...timeOffReasons, 'Company'])
    }, [user.is_admin])


    const createTimeOffRequest = useCallback(async () => {
        try {
            setLoadingModal(true)
            setErrors(null)
            const response = await TimeOffService.create(user.id, Date.parse(fromDate) / 1000, (Date.parse(toDate) / 1000)+86399, requestNote, reason?.toLowerCase())
            showToast(response.data.message, response.data.data.status === 'declined' ? 'error' : "success")
            setLoadingModal(false)
            hideModal()
            onCreate()
        } catch(err){
            setLoadingModal(false)
            const errorMessage = err.response?.data?.message || err.message || "Failed to create time off request"
            showToast(errorMessage, "error")
            setErrors(err.response?.data?.data || {})
        }
    }, [fromDate, toDate, user, hideModal, onCreate, reason, requestNote, setLoadingModal])

    const handleSaveRequest = useCallback(() => {
        createTimeOffRequest()
    }, [createTimeOffRequest])   

    const handleReasonSelect = (reason) => {
        setReason(reason)
    }

    const checkIfButtonShouldBeDisabled = () => {
        if(fromDate && toDate && reason ) return false
        return true
    }

    const getMinDateFrom = () => {
        return new Date()
    }

    useKeypress('Enter', createTimeOffRequest)
    useKeypress('Escape', hideModal)

    return (
        <Wrapper>
                <>
                    <h3>Create Time Off Request</h3>
                    <div className="dropdown-container">
                        <label>REASON</label>
                        <Dropdown error={errors && 'reason' in errors && errors.reason[0]} placeholder={"Select reason"} value={reason && reason}>
                            {timeOffReasons.map(reason => <div key={reason} className="dropdown-option" onClick={() => handleReasonSelect(reason)}>{reason}</div>)}
                        </Dropdown>
                    </div>
        
                    <div className="from-to">
                        <div className="from">
                            <label>FROM</label>
                            <Calendar minDate={getMinDateFrom()} startDate={fromDate} setStartDate={setFromDate}/>
                        </div>
                        <div className="to">
                            <label>TO</label>
                            <Calendar minDate={fromDate ? fromDate : new Date()} startDate={toDate} setStartDate={setToDate}/>
                        </div>
                    </div>
    
                    <TextArea label="NOTE" error={errors && 'note' in errors && errors.note[0]} rows={10} maxLength={300} value={requestNote} onChange={(e) => setRequestNote(e.target.value)} />
                    <div className="button-group">
                        <div className="cancel-button"  onClick={() => hideModal()}>Cancel</div>
                        <Button disabled={checkIfButtonShouldBeDisabled()} value={"Save"} width={100}  onClick={handleSaveRequest}/>
                    </div>

                </>


        </Wrapper>
    )
}

export default CreateTimeOffRequest
